/* eslint-disable no-undef */
import { memo, useEffect, useMemo, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Box, Typography } from "@mui/material";

const DEFAULT_ZOOM = 13;

const containerStyle = {
  width: "100%",
  height: "100%",
};

function Map({ details }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  const lat = Number(details?.latitude);
  const lng = Number(details?.longitude);
  const hasValidCoords = Number.isFinite(lat) && Number.isFinite(lng);
  const ready = Boolean(details?.id && hasValidCoords);

  const center = useMemo(() => ({ lat, lng }), [lat, lng]);

  const [activeMarker, setActiveMarker] = useState(null);

  useEffect(() => {
    setActiveMarker(null);
  }, [details?.id]);

  if (loadError) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">Map could not load.</Typography>
      </Box>
    );
  }

  if (!isLoaded || !ready) {
    return null;
  }

  return (
    <GoogleMap
      key={details.id}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={DEFAULT_ZOOM}
      options={{
        maxZoom: 16,
      }}
    >
      <Marker
        title={details?.nmi}
        position={center}
        onClick={() => setActiveMarker(details)}
      >
        {activeMarker?.id === details?.id ? (
          <InfoWindow onCloseClick={() => setActiveMarker(null)}>
            <Box width="200px">
              <Typography>{details?.nmi}</Typography>
            </Box>
          </InfoWindow>
        ) : null}
      </Marker>
    </GoogleMap>
  );
}

export default memo(Map);
